import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import { LayoutGrid, ChevronRight, MapPin } from 'lucide-react';

const Hub = ({ onSelect }: { onSelect: (org: any) => void }) => {
    const [orgs, setOrgs] = useState<any[]>([]);
    const [hoveredId, setHoveredId] = useState<number | null>(null);
    const token = localStorage.getItem('token');

    useEffect(() => {
        axios.get(`${API_URL}/admin/organizations`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => setOrgs(res.data));
    }, [token]);

    return (
        <div className="hub-container">
            {/* ── HEADER ── */}
            <div className="hub-header">
                <LayoutGrid size={28} color="#3b82f6" />
                <h1 className="hub-title">
                    Wybierz Organizację
                </h1>
            </div>

            {/* ── GRID KART ── */}
            <div className="hub-grid">
                {orgs.map(org => (
                    <div
                        key={org.id}
                        onClick={() => onSelect(org)}
                        onMouseEnter={() => setHoveredId(org.id)}
                        onMouseLeave={() => setHoveredId(null)}
                        className={`hub-card ${hoveredId === org.id ? 'hovered' : ''}`}
                    >
                        {/* Ikona + nazwa */}
                        <div className="hub-card-top">
                            <div className="hub-card-icon">
                                <MapPin size={20} color="#3b82f6" />
                            </div>
                            <h3 className="hub-card-name">
                                {org.name}
                            </h3>
                        </div>

                        {/* Współrzędne */}
                        <p className="hub-card-coords">
                            {org.latitude.toFixed(3)}, {org.longitude.toFixed(3)}
                        </p>

                        {/* CTA */}
                        <div className="hub-card-cta">
                            Wejdź do panelu <ChevronRight size={16} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Hub;